import { filter as _filter } from 'lodash';

const localeFilter = <T>(data: T[], locale: string) => _filter(data, (node: any) => node.locale === locale)[0];

export const localeFilterList = <T>(data: T[], locale: string) => _filter(data, (node: any) => node.locale === locale);

export default localeFilter;
